import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6" }

import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'

import ReportChart from '@/components/reports/ReportChart.vue'
import { parseReferralCodeUsageReport } from '@/services/reportParser.service'
import api from '@/store/api'


export default {
  __name: 'ReferralCodeDetail',
  setup(__props) {

const route = useRoute()

const referralCodeId = computed(() => route.params.id)
const discountCodeId = computed(() => route.query.discount_code_id || null)
const codeNameFromQuery = computed(() => route.query.code || null)

const loading = ref(false)
const chartData = ref({ labels: [], datasets: [] })
const tableData = ref(null)
const codeName = ref('')

const pageTitle = computed(() => {
  return codeNameFromQuery.value || codeName.value || 'Referral Code'
})

const fetchReportData = async () => {
  loading.value = true
  try {
    const end = new Date()
    const start = new Date(end)
    start.setDate(end.getDate() - 90)
    const toYMD = d => d.toISOString().slice(0, 10)

    const params = new URLSearchParams({
      beginning_date: toYMD(start),
      ending_date: toYMD(end),
      group_by: 'day'
    })
    params.append('referral_code_ids[]', discountCodeId.value || referralCodeId.value)

    const res = await api.call('GET', `data_downloads/reports/referral_code_usage_report?${params.toString()}`)
    const parsed = parseReferralCodeUsageReport(res)
    chartData.value = parsed.chartData
    tableData.value = parsed.tableData

    // Extract code name from parsed data if not passed via query
    if (!codeNameFromQuery.value && parsed.tableData?.rows?.length) {
      codeName.value = parsed.tableData.rows[0].label || ''
    }
  } catch (error) {
    console.error('Error fetching referral code detail report:', error)
  } finally {
    loading.value = false
  }
}

fetchReportData()

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        text: pageTitle.value,
        "save-status": false,
        sections: [{ id: 'overview', name: 'Overview', active: true }]
      }, null, 8, ["text"])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_NeueLoading, { loading: loading.value }, {
            default: _withCtx(() => [
              _createVNode(ReportChart, {
                "report-id": `referral-code-detail-${referralCodeId.value}`,
                title: pageTitle.value,
                description: "Last 90 days",
                "empty-state-title": "No usage in the last 90 days",
                "empty-state-description": "Share this referral code to start seeing usage data here.",
                "label-column-title": "Name",
                "chart-data": chartData.value,
                "has-supporting-table": true,
                "table-data": tableData.value,
                "chart-type": "line",
                "date-filter": false,
                "dropdown-filter": false,
                loading: loading.value,
                "table-hover-enabled": false,
                "view-report-link": '/referral-code-usage?code_id=' + (discountCodeId.value || referralCodeId.value)
              }, null, 8, ["report-id", "title", "chart-data", "table-data", "loading", "view-report-link"])
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

}